import { baseApi } from 'app/services/baseApi';
import { OrganizationTypesResponse } from './organizationTypes';

export const organizationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSupportedDocTypesByOrg: builder.query<OrganizationTypesResponse, void>({
      query: () => ({
        url: '/orgsupporteddocumenttypes',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetSupportedDocTypesByOrgQuery } = organizationApi;
